import { NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";

// FIXED: Re-imported all the necessary icons
import { BarChart, User, List, Store, Settings } from "lucide-react";

const NavbarContainer = styled.nav`
  background: #121212;
  backdrop-filter: blur(10px);
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 72px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;

  @media (min-width: 768px) {
    height: 80px;
  }
`;

const NavItem = styled(NavLink)<{ $isActive: boolean }>`
  color: ${(props) => (props.$isActive ? "#ccff00" : "#8A8A8E")};
  text-decoration: none;
  font-size: 0.65rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  width: 20%;
  height: 100%;
  gap: 4px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;

  &:hover {
    color: #ccff00;
    transform: translateY(-2px);
  }

  ${(props) =>
    props.$isActive &&
    `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 30px;
      height: 3px;
      background: #ccff00;
      border-radius: 3px;
    }
  `}

  @media (min-width: 768px) {
    font-size: 0.75rem;
  }
`;

const AdminNav = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <NavbarContainer>
      <NavItem to="/admin/stats" $isActive={isActive("/admin/stats")}>
        <BarChart color={isActive("/admin/stats") ? "#ccff00" : "#8A8A8E"} />
        Stats
      </NavItem>

      <NavItem to="/admin/users" $isActive={isActive("/admin/users")}>
        <User color={isActive("/admin/users") ? "#ccff00" : "#8A8A8E"} />
        Users
      </NavItem>

      <NavItem
        to="/admin/manage-tasks"
        $isActive={isActive("/admin/manage-tasks")}
      >
        <List color={isActive("/admin/manage-tasks") ? "#ccff00" : "#8A8A8E"} />
        Tasks
      </NavItem>

      <NavItem to="/admin/items" $isActive={isActive("/admin/items")}>
        <Store color={isActive("/admin/items") ? "#ccff00" : "#8A8A8E"} />
        Items
      </NavItem>

      <NavItem to="/admin/settings" $isActive={isActive("/admin/settings")}>
        <Settings color={isActive("/admin/settings") ? "#ccff00" : "#8A8A8E"} />
        Settings
      </NavItem>
    </NavbarContainer>
  );
};

export default AdminNav;
